import React, { useEffect, useRef } from 'react';

export default function ConfirmSize2(props) {
  const { getSize2, location, getConfirmSneakerSize2, setConfirmSneakerSize2 } = props;
  const strings = window.themeStrings || {};

  const confirmationOptions = [
    { value: "Rarely", label: strings.fit_finder_step2_rarely },
    { value: "Occasionally", label: strings.fit_finder_step2_occasionally },
    { value: "Frequently", label: strings.fit_finder_step2_frequently }
  ];

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      if (!getConfirmSneakerSize2) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <fieldset className="form-field" ref={ref}>
      <legend className="form-legend">
        {strings.fit_finder_step2_how_often_wear.replace('{size}', getSize2[location.code])}
      </legend>
      <div className="option-values option-values-one-per-line">
        {confirmationOptions.map((option, index) => {
          return <div className="option-value" key={index}>
            <input
              type="radio"
              className="option-value-input"
              id={`confirm-size2-${index}`}
              name="confirm-size2"
              value={option.value}
              checked={getConfirmSneakerSize2 === option.value}
              onChange={() => setConfirmSneakerSize2(option.value)} />
            <label htmlFor={`confirm-size2-${index}`} className="option-value-name">{option.label}</label>
          </div>
        })}
      </div>
    </fieldset>
  );
}